export const SNOWPLOW_APP_ID = 'montu-au.umeds-customer';
export const SNOWPLOW_TRACKER_NAME = 'hoc.customer-portal';
